import axios from 'axios'
import { Product } from 'store/types'

type Config = {
  pathParams: {
    id?: number
  }
  params: {
    'google-token'?: string
  }
}

type Resp = Product

export default async (config: Config): Promise<Resp> => {
  const { pathParams, params } = config
  const response = await axios.get(`${process.env.REACT_APP_PLUSBOX_API}/products/${pathParams.id}`, {
    params
  })
  return response.data
}

export type { Config }
